// extracted by mini-css-extract-plugin
export default {"columns11":"ParentForm_columns11__6JRUZ"};